enum AccountPlanPeriod {
  'Monthly' = 'Monthly',
  'Yearly' = 'Yearly',
}

export default AccountPlanPeriod;
